"use client";
import { Button, chakra, Stack, VStack } from "@chakra-ui/react";
import { Link, LinkBox } from "@areahub/ui/components/link";
import PostCard, { PostPreview } from "../article-card/card";

interface PreviewPostsProps {
  category?: {
    slug: string;
    name: string;
  };
  posts?: PostPreview[];
  prev?: PostPreview;
  next?: PostPreview;
}

export const PreviewPosts = ({
  category,
  posts,
  prev,
  next,
}: PreviewPostsProps) => {
  const url = `/individuals/knowledge-center/category/${category?.slug}`;

  return (
    <chakra.aside bg="indigo.800">
      <Stack
        flexDirection={{
          base: "column-reverse",
          lg: "row",
        }}
        flexWrap="wrap"
        mx="auto"
        spacing={{
          base: "6",
          lg: "12",
        }}
        gap={{
          base: 5,
          lg: "unset",
        }}
        maxW="7xl"
        px={{
          sm: "4",
          md: "6",
        }}
        py={{
          base: "6",
          lg: "12",
        }}
        mt={{
          base: "6",
          lg: "12",
        }}
        color="white"
      >
        <chakra.article
          flex="1/2"
          px="6"
          py="4"
          bg="indigo.700"
          borderRadius="lg"
          mr={{ lg: "4" }}
          maxW={{
            lg: "30%",
          }}
        >
          <chakra.header>
            <chakra.h3 apply="styles.mdx.h3" color="white">
              Related to{" "}
              {category ? (
                <Link
                  href={url}
                  color={"white"}
                  _hover={{
                    color: "currentColor",
                    textDecor: "none",
                    display: "inline-block",
                  }}
                >
                  {category.name}
                </Link>
              ) : (
                "This Article"
              )}
            </chakra.h3>
          </chakra.header>
          <VStack
            spacing={{
              base: "6",
              lg: "12",
            }}
          >
            <chakra.ul w="100%">
              {posts?.map((post, i) => (
                <chakra.li key={i} listStyleType="none" pt="2">
                  <LinkBox>
                    <Link
                      href={`/individuals/knowledge-center/${
                        post.aggregatePostPage
                          ? post.aggregatePostPage?.slug + "/"
                          : ""
                      }${post.slug}`}
                      isOverlay
                      color="white"
                      _hover={{
                        textDecoration: "underline",
                      }}
                    >
                      {post.title}
                    </Link>
                    <chakra.p>-{` ${post.readingTime} min read`}</chakra.p>
                  </LinkBox>
                </chakra.li>
              ))}
            </chakra.ul>
          </VStack>
          <footer>
            <Link href={url}>
              <Button
                variant="outline"
                color="white"
                _hover={{ color: "indigo.700", bg: "white" }}
                mt="6"
              >
                See all {category?.name} posts →
              </Button>
            </Link>
          </footer>
        </chakra.article>
        {prev && prev.slug && (
          <chakra.div
            flex="1"
            px={{ lg: "4" }}
            marginTop="0 !important"
            color="black"
          >
            <PostCard
              {...{ post: prev }}
              bg="indigo.700"
              border="none"
              color="white"
              tagSx={{
                color: "indigo.200",
              }}
            />
          </chakra.div>
        )}
        {next && (
          <chakra.div
            flex="1"
            px={{ lg: "4" }}
            marginTop="0 !important"
            color="black"
            maxW={{
              lg: "xl",
            }}
          >
            <PostCard
              {...{ post: next }}
              bg="indigo.700"
              border="none"
              color="white"
              tagSx={{
                color: "indigo.200",
              }}
            />
          </chakra.div>
        )}
      </Stack>
    </chakra.aside>
  );
};

export default PreviewPosts;
